export function getPreviousSeason(currentSeason) {
  // Separar el año de inicio y fin de la temporada actual
  const [startYear, endYear] = currentSeason.split("/").map(Number);

  // Restar 1 a ambos años para obtener la temporada anterior
  const previousStartYear = startYear - 1;
  const previousEndYear = endYear - 1;

  // Formatear la temporada anterior
  const previousSeason = `${previousStartYear}/${previousEndYear}`;

  return previousSeason;
}
